'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { getDefaultRegistry } from '../../utils/defaults';
import { getDefaultValue } from '../../utils/additionalPropertyUtils';
import UnderConstruction from '../../../Doc/components/UnderConstruction';
import CollapseFieldWrapper from './shared/CollapseFieldWrapper';
import TextInput from '../inputs/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class StringField extends Component {
  constructor(...args) {
    super(...args);
    this.getPlaceholder = () => {
      const {
        isAdditionalProperty,
        placeholder
      } = this.props;
      if (placeholder !== undefined) {
        return placeholder;
      }
      if (isAdditionalProperty) {
        return getDefaultValue('string');
      }
      return null;
    };
  }
  render() {
    const {
      autoFocus,
      collapsed,
      disabled,
      formData,
      idSchema,
      isAdditionalProperty,
      name,
      onChange,
      readOnly,
      registry,
      required,
      schema
    } = this.props;
    const {
      title,
      format
    } = schema;
    const {
      formContext
    } = registry;
    if (format) {
      return /*#__PURE__*/_jsx(UnderConstruction, {
        component: `StringField: ${format}`
      });
    }
    return /*#__PURE__*/_jsx(CollapseFieldWrapper, {
      collapsed: collapsed,
      formData: formData,
      isAdditionalProperty: isAdditionalProperty,
      children: /*#__PURE__*/_jsx(TextInput, {
        autoFocus: autoFocus,
        formContext: formContext,
        id: idSchema && idSchema.$id,
        disabled: disabled,
        label: title || name,
        onChange: onChange,
        placeholder: this.getPlaceholder(),
        readOnly: readOnly,
        required: required,
        schema: schema,
        value: formData || ''
      })
    });
  }
}
StringField.propTypes = {
  autoFocus: PropTypes.bool,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  formData: PropTypes.any,
  idSchema: PropTypes.object,
  isAdditionalProperty: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  registry: PropTypes.object,
  required: PropTypes.bool,
  schema: PropTypes.object
};
StringField.defaultProps = {
  disabled: false,
  readOnly: false,
  registry: getDefaultRegistry()
};